<template>
  <d-container>
    <v-form v-if="!loading" ref="form" :action="action" :model="model" />
  </d-container>
</template>

<script>
import form from "./_form.vue";

export default {
  components: {
    "v-form": form
  },
  metaInfo() {
    return {
      title: this.$t("new_property")
    };
  },
  data() {
    return {
      model: null,
      action: "create",
      loading: true
    };
  },
  mounted() {
    const reset = this.$route.query.reset;
    const propertyId = this.$route.query.id;

    if (reset != undefined && propertyId != undefined) {
      this.resetProperty(propertyId);
    } else {
      this.loading = false;
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
    resetProperty(propertyId) {
      this.$http
        .delete(
          this.$laravel.route("api.properties.destroy", {
            property: propertyId
          })
        )
        .then(response => {
          this.action = "reset";
          this.model = response.data.property;
          this.loading = false;
        });
    }
  }
};
</script>
